import { Stack } from "@mui/material";
import { useAtom } from "jotai/index";
import { useEffect } from "react";

import RoomManagementModule from "@/module/room-management-module/room-management-module";
import { headerTitle } from "@/store/store";

const RoomManagementPage = ({ name }: { name: string }) => {
  const [, setHeaderTitle] = useAtom(headerTitle);
  useEffect(() => {
    setHeaderTitle(name);
  }, [setHeaderTitle, name]);

  return (
    <Stack spacing={2} sx={{ height: "100%", flexWrap: "nowrap" }}>
      <RoomManagementModule domain={name} />
    </Stack>
  );
};

export default RoomManagementPage;
